export function useScroll(element: HTMLElement | null, offset: number): void {
  if (element) {
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.pageYOffset - offset,
      behavior: "smooth",
    });
  }
}
